// extracted by mini-css-extract-plugin
export default {"wrap":"BF-z","fullWidth":"CF-z","hideOnDesktop":"DF-z","content":"EF-z","hasOpenedNav":"FF-z","crumbsList":"GF-z","dropdownsWrap":"HF-z"};